<template>
  <div>
    <modal-edit-want-buy ref="editWantBuy"></modal-edit-want-buy>
    <modal-add-want-buy ref="addWantBuy"></modal-add-want-buy>
    <v-row>
      <v-col>
        <v-btn
            class="ma-2"
            color="blue"
            dark
            @click="showAddWantBuyModal"
        >
          Dodaj
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <data-table
            ref="table"
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
        >
          <template v-slot:item.id="{ item }">
            {{ item.id }}
          </template>
          <template v-slot:item.quantity="{ item }">
            {{ item.quantity }} {{ item.category.unit }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-select
                style="width:200px"
                v-model="item.status"
                label="Status"
                placeholder=" "
                :items="statusValues"
                item-value="value"
                item-text="text"
                @change="update(item)"
            />
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ localDateTime(item.createdAtDto) }}
          </template>
          <template v-slot:item.update="{ item }">
            <v-btn
                class="ma-2"
                color="blue"
                dark
                @click="showEditWantBuyModal(item, $event)"
            >
              Edycja
              <v-icon
                  dark
                  right
              >
                mdi-table-edit
              </v-icon>
            </v-btn>
            <v-btn
                class="ma-2"
                color="green"
                dark
                :to="{name: 'offer-want-buys-details', params: { id: item.id }}"
            >
              Zgłoszenia
              <v-icon
                  dark
                  right
              >
                mdi-account-arrow-right
              </v-icon>
            </v-btn>
          </template>
        </data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '../services/api';
import DataTable from "@/components/data-table/DataTable";
import formatters from '@/mixins/formatters';
import {OfferWantBuyStatus, getStatusText} from '@/enums/OfferWantBuyStatus';
import permissions from '@/mixins/permissions';
import ModalEditWantBuy from "@/components/ModalEditWantBuy";
import ModalAddWantBuy from "@/components/ModalAddWantBuy.vue";

export default {
  mixins: [
    formatters,
    permissions,
  ],
  components: {
    ModalAddWantBuy,
    ModalEditWantBuy,
    DataTable,
  },
  data() {
    return {
      status: null,
      statuses: OfferWantBuyStatus,
      total: 0,
      options: {},
      items: [],
      loading: true,
      headers: [
        {text: 'ID', value: 'id', sortable: false},
        {text: 'Imię i nazwisko', value: 'name', sortable: false},
        {text: 'E-mail', value: 'email', sortable: false},
        {text: 'Telefon', value: 'phone', sortable: false},
        {text: 'NIP', value: 'nip', sortable: false},
        {text: 'Kategoria', value: 'category.name', sortable: false},
        {text: 'Pożądana ilość', value: 'quantity', sortable: false},
        {text: 'Proponowany kod', value: 'code', sortable: false},
        {text: 'Tytuł', value: 'title', sortable: false},
        {text: 'Opis', value: 'description', sortable: false},
        {text: 'Status', value: 'status', sortable: false},
        {text: 'Akcje', value: 'update', sortable: false},
      ],
      statusValues: [
        {
          value: 'new',
          text: 'Nowy'
        },
        {
          value: 'processing',
          text: 'Przetwarzanie'
        },
        {
          value: 'completed',
          text: 'Zakończone'
        },
        {
          value: 'published',
          text: 'Opublikowane'
        },
      ]
    }
  },
  methods: {
    async getList() {
      this.loading = true;

      const {page, itemsPerPage} = this.options;

      const params = {
        offset: page > 1 ? itemsPerPage * (page - 1) : 0,
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      const response = await api.get('/api/offer/want-buys/category', {params});
      this.loading = false;

      this.items = response.data.items;
      this.total = response.data.total; // Delay the change a bit to avoid performing another query.
    },
    getStatusText(status) {
      return getStatusText(status);
    },

    update(item) {
      api.put('/api/offer/want-buys/' + item.id, {status: item.status});
    },
    showEditWantBuyModal(item) {
      this.$refs.editWantBuy
          .open(item)
    },
    showAddWantBuyModal() {
      this.$refs.addWantBuy
          .open()
    }
  },
  created() {
    this.getList();
  }
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-chip {
  white-space: break-spaces !important;
  line-height: 14px;
  width: 100%;
  padding: 9px;
}

.v-chip .v-chip__content {
  max-width: 100%;
  height: auto;
  overflow: auto;
  min-height: 32px;
  white-space: pre-wrap;
}
</style>